import { NavLink } from 'react-router-dom';
import { NAV, type NavItem } from './nav';
import { Brand } from './Brand';
import { Badge } from '@/components/ui/badge';
import { useAdminRole } from '@/lib/auth/store';
import { cn } from '@/lib/utils/cn';

function NavRow({ item, onNavigate }: { item: NavItem; onNavigate?: () => void }) {
  const Icon = item.icon;

  if (item.soon) {
    return (
      <div
        className="flex min-h-[44px] cursor-not-allowed items-center gap-3 rounded-md px-3 py-2 text-sm text-sidebar-foreground/40 lg:min-h-0"
        title="Coming soon"
      >
        <Icon className="h-[18px] w-[18px] shrink-0" />
        <span className="flex-1 truncate">{item.label}</span>
        <span className="rounded bg-sidebar-accent px-1.5 py-0.5 text-[9px] uppercase tracking-wide text-sidebar-foreground/50">
          Soon
        </span>
      </div>
    );
  }

  return (
    <NavLink
      to={item.to}
      end={item.end}
      onClick={onNavigate}
      className={({ isActive }) =>
        cn(
          'flex min-h-[44px] items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors lg:min-h-0',
          isActive
            ? 'bg-primary/15 text-white'
            : 'text-sidebar-foreground/80 hover:bg-sidebar-accent hover:text-white',
        )
      }
    >
      {({ isActive }) => (
        <>
          <Icon className={cn('h-[18px] w-[18px] shrink-0', isActive && 'text-primary')} />
          <span className="flex-1 truncate">{item.label}</span>
        </>
      )}
    </NavLink>
  );
}

export function SidebarContent({ onNavigate }: { onNavigate?: () => void }) {
  const role = useAdminRole();

  return (
    <div className="flex h-full flex-col bg-sidebar text-sidebar-foreground">
      <div className="flex h-14 items-center border-b border-sidebar-border px-4">
        <Brand />
      </div>

      <nav className="flex-1 space-y-5 overflow-y-auto px-3 py-4">
        {NAV.map((section) => {
          const items = section.items.filter((i) => !(i.superOnly && role !== 'SUPER_ADMIN'));
          if (items.length === 0) return null;
          return (
            <div key={section.title}>
              <p className="px-3 pb-1.5 text-[10px] font-semibold uppercase tracking-widest text-sidebar-foreground/40">
                {section.title}
              </p>
              <div className="space-y-0.5">
                {items.map((item) => (
                  <NavRow key={item.to} item={item} onNavigate={onNavigate} />
                ))}
              </div>
            </div>
          );
        })}
      </nav>

      <div className="border-t border-sidebar-border px-4 py-3">
        <Badge variant="outline" className="border-sidebar-border text-[10px] text-sidebar-foreground/60">
          v0.1 · Phase A
        </Badge>
      </div>
    </div>
  );
}
